var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "app-navigation-header" },
    [
      _c("AppNavigationHeaderDatePicker"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "new-event-today-view-section" },
        [
          !_vm.isPublic ? _c("AppNavigationHeaderNewEvent") : _vm._e(),
          _vm._v(" "),
          _c("AppNavigationHeaderTodayButton"),
          _vm._v(" "),
          _c("AppNavigationHeaderViewMenu")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }